import React, { useState } from "react";
import FaiBox from "../../../MuiComponents/FaiBox";
import FaiTypography from "../../../MuiComponents/FaiTypography";
import theme from "../../../assets/theme";
import FaiButton from "../../../MuiComponents/FaiButton";
import HeaderBar from "./component/HeaderBar";
import ProductList from "./component/ProductList";
import dataTableData from "./data/dataTableData";
import { useDebounce } from "../../../hooks/useDebounce";

function Inventory() {
	const { typography } = theme;
	const [filters, setFilters] = useState({ isDraft: false });
	const filtersValue = useDebounce(filters, 500);

	const handleFilterChange = (newFilters: any) => {
		setFilters({ ...newFilters, isDraft: false });
	};

	return (
		<FaiBox className={"inventory"}>
			<FaiTypography
				variant={"h4"}
				fontWeight={typography.fontWeightMedium}
				mb={"21px"}
			>
				Inventory
			</FaiTypography>
			<FaiBox className={"inventory-content"}>
				<FaiBox className={"inventory-content-header"}>
					<HeaderBar onFilterChange={handleFilterChange} />
				</FaiBox>
				<FaiBox className={"inventory-content-body"} mt={3}>
					<ProductList data={dataTableData} filters={filtersValue} />
				</FaiBox>
			</FaiBox>
		</FaiBox>
	);
}

export default Inventory;
